import { getCookie, getTranslations } from "./utils";

export const ALLOWED_LANGUAGES = ["en", "de", "fr", "es", "it", "pt-br", "nl"];
export const JSON_VERSION = process.env.REACT_APP_JSON_VERSION;

export const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_NAME;
export const CLOUDINARY_IMAGE_BASE_URL =
  process.env.REACT_APP_CLOUDINARY_BASE_NAME;

export const DESKTOP = "Desktop";
export const TABLET = "Tablet";
export const MOBILE = "Mobile";

export const PROFANE_AND_PROVISIONAL = "PROFANE_AND_PROVISIONAL";
export const UPDATED_BY_SYSTEM = "UPDATED_BY_SYSTEM ";

export const MOBILE_SM_MIN_WIDTH = "(min-width: 0px)";
export const MOBILE_SM_MAX_WIDTH = "(min-width: 320px)";
export const MOBILE_MIN_WIDTH = "(min-width: 321px)";
export const MOBILE_MAX_WIDTH = "(max-width: 576px)";
export const TABLET_MIN_WIDTH = "(min-width: 577px)";
export const TABLET_MAX_WIDTH = "(max-width: 768px)";
export const LAPTOP_SM_MIN_WIDTH = "(min-width: 769px)";
export const LAPTOP_SM_MAX_WIDTH = "(min-width: 1024px)";
export const LAPTOP_MD_MIN_WIDTH = "(min-width: 1025px)";
export const LAPTOP_MD_MAX_WIDTH = "(min-width: 1160px)";
export const LAPTOP_MIN_WIDTH = "(min-width: 1161px)";
export const LAPTOP_MAX_WIDTH = "(max-width: 1319px)";
export const DESKTOP_MIN_WIDTH = "(min-width: 1320px)";

export const FANTASY_ANDROID = "fantasy_android";
export const FANTASY_IOS = "fantasy_iOS";
export const FANTASY_WEBSITE = "fantasy_website";

export const PERSONAL = "PERSONAL";
export const SEASON = "SEASON";

export const EOT_USER_API_1 = "services/user/cards/{{socialId}}/eos";
export const EOT_USER_API_2 = "feeds/eos/user/{{socialId}}.json";

export const SUBSCRIPTION_PACKAGE_TYPE = "SUBSCRIPTION_PACKAGE";
export const ADDITIONAL_SUBSCRIPTIONS_TYPE = "ADDITIONAL_SUBSCRIPTIONS";
export const F1_TV_PRO_ANNUAL = "F1 TV Pro Annual";
export const F1_TV_PRO_MONTHLY = "F1 TV Pro Monthly";
export const F1_TV_ACCESS_ANNUAL = "F1 TV Access Annual";
export const F1_TV_ACCESS_MONTHLY = "F1 TV Access Monthly";
export const PRO_ANNUAL = "Pro Annual";
export const PRO_MONTHLY = "Pro Monthly";
export const ACCESS_ANNUAL = "Access Annual";
export const ACCESS_MONTHLY = "Access Monthly";

export const WEB = "Web";
export const WEBVIEW = "WebView";

export const INTERNAL = "internal";

export const CREATE_LEAGUE = "create-league";
export const JOIN_LEAGUE = "join-league";

export const LANDSCAPE = "Landscape";
export const PORTRAIT = "Portrait";

export const STANDINGS = "Standings";
export const GAMING = "Gaming";
export const MORE = "More";
export const RESULTS = "Results";

export const REGISTER = "register";
export const LOGIN = "login";
export const SIGN_IN = "sign in";
export const MY_ACCOUNT = "my-account";
export const SUBSCRIBE = "Subscribe";
export const MANAGE_MY_ACCOUNT = "Manage My Account";

export const WEEKEND = "Weekend";
export const QUALIFYING = "Qualifying";
export const RACE = "Race";
export const SPRINT = "Sprint";

export const DRIVER = "DRIVER";
export const CONSTRUCTOR = "CONSTRUCTOR";

export const TOTAL = "Total";

export const MAX_DRIVERS = 5;
export const MAX_CONSTRUCTORS = 2;
export const MAX_TEAM_NAME_CHARACTERS = 25;
export const MIN_TEAM_NAME_CHARACTERS = 6;
export const MAX_MENU_ITEMS = 3;

export const ONE_SECOND = 1000;
export const ONE_MINUTE = ONE_SECOND * 60;
export const ONE_HOUR = ONE_MINUTE * 60;
export const ONE_DAY = ONE_HOUR * 24;

export const MIX_API_INTERVAL = 10000;
export const MIX_API_KEY = "si-mix-api-buster";
export const MIX_API_LIVE_KEY = "si-mix-api-live-buster";

export const IMAGE_VERSION =
  typeof getCookie === "function" && getCookie(MIX_API_KEY)
    ? getCookie(MIX_API_KEY)
    : process.env.REACT_APP_IMAGE_VERSION;

export const ANNOUNCEMENT_INFO_POPUP_KEY = (language) =>
  `si-${language}-info-popup`;

export const ANNOUNCEMENT_WHATS_NEW_KEY = (language) =>
  `si-${language}-whats-new`;

export const BUILD_VERSION = "si-bv";
export const BUILD_REFRESH = "si-bv-refresh";

export const OPT_TYPE = 1;
export const PLATFORM_ID = 1;
export const PLATFORM_VERSION = "1";
export const PLATFORM_CATEGORY = "web";
export const CLIENT_ID = 1;

export const MAX_BUDGET = 100;
export const EXTRA_TRANSFER_COST = 10;
export const TRENDS_MIN_RACE_WEEK = 2;

export const MAX_LEAGUE_MEMBERS = 99999999;
export const MIN_LEAGUE_CODE_LENGTH = 11;
export const MAX_LEAGUE_NAME_CHARACTERS = 25;
export const MIN_LEAGUE_NAME_CHARACTERS = 3;

export const UPCOMING_TIMER_OFFSET = 40;

export const RACE_WEEKEND =
  typeof getTranslations === "function" &&
  getTranslations("my_team_race_weekend", "Race Weekend");
export const COMPLETED =
  typeof getTranslations === "function" &&
  getTranslations("my_team_completed_races", "Completed");

export const TYPE_F1_LOGIN_OFFLINE_MODE = "TYPE_F1_LOGIN_OFFLINE_MODE";

export const RE_RENDER_LOCAL_STORAGE_KEY = "si-tab-re-render";

export const cf_user_team_create = {
  EXP_INVALID_USER_DB_INSTANCE: 1051,
  EXP_GAMEDY_LOCKED: 1052,
  EXP_USER_NOT_FOUND: 1053,
  EXP_TEAM_ALREADY_CREATED: 1054,
  EXP_IVALID_GAMEDAY_PLAYER_COUNT: 1055,
  EXP_IVALID_TEAM_COUNT: 1056,
  EXP_DUPLICATE_PLAYERID_FOUND: 1057,
  EXP_INVALID_TEAM_NO: 1058,
  EXP_TEAM_VALUE_EXCEEDED: 1059,
  EXP_CAPTAIN_DOES_NOT_EXISTS: 1060,
  EXP_TEAM_NAME_EXISTS: 1061,
  EXP_TEAM_NAME_LENGTH_NOT_MATCH: 1062,
  PROFANITY_CHECK: -71,
  EXP_ACHIVEMENT_TEAM1: 1063,
  EXP_ACHIVEMENT_TEAM3: 1064,
};

export const leagueMembersConstants = {
  ITEMS_PER_PAGE: 10,
};

export const cf_user_league_create = {
  EXP_TEAM_NOT_FOUND: 1501,
  EXP_LEAGUE_COUNT_EXCEEDED: 1502,
  EXP_LEAGUE_NAME_NULL: 1503,
  EXP_ACHIVEMENT_ALREADY_UNLOCK: 1504,
  EXP_TEAM_COUNT_NOT_MATCH: 1505,
  EXP_DUBLICATE_TEAM_NO_FOUND: 1506,
  PROFANITY_CHECK: -71,
  LEAGUE_NAME_MORE_THAN_50_CHARACTERS: 15,
};

export const cf_user_league_create_error_messages = {
  "-1": "Something went wrong",
  [cf_user_league_create.EXP_TEAM_NOT_FOUND]: "Team not found",
  [cf_user_league_create.EXP_LEAGUE_COUNT_EXCEEDED]:
    "Max leagues count reached",
  [cf_user_league_create.EXP_LEAGUE_NAME_NULL]: "Invalid League name",
  [cf_user_league_create.EXP_ACHIVEMENT_ALREADY_UNLOCK]:
    "Achievement already unlocked",
  [cf_user_league_create.EXP_TEAM_COUNT_NOT_MATCH]: "Team count mismatch",
  [cf_user_league_create.EXP_DUBLICATE_TEAM_NO_FOUND]:
    "You team is already a part of this league",
  [cf_user_league_create.PROFANITY_CHECK]: "Kindly enter a valid League name",
  [cf_user_league_create.LEAGUE_NAME_MORE_THAN_50_CHARACTERS]:
    "League name must not be more than 50 characters",
};

export const cf_user_league_create_error_headers = {
  [cf_user_league_create.PROFANITY_CHECK]: "League name not allowed",
};

export const cf_user_league_info = {
  AGE_REGION_RESTRICTED: 9876,
};

export const F1_FANTASY_COOKIE = "F1_FANTASY_007";
export const TA_CMP_COOKIE_PREFERENCES = "cmapi_cookie_privacy";
export const TA_CMP_FUNCTIONAL_COOKIE_PERMIT = "2";

export const boosterIdKey = {
  1: "limitless",
  2: "wildcard",
  3: "finalFix",
  4: "autoPilot",
  5: "noNegative",
  6: "extraDRS",
};

export const getLeagueBadge = (key) => {
  const leagueBadgeList = {
    Popular: {
      matchStatusText:
        typeof getTranslations === "function" &&
        getTranslations("league_badge_popular", "Popular"),
      matchStatusIcon: "f1i-star-filled",
      matchStatusCls: "si-popular",
    },
    New: {
      matchStatusText:
        typeof getTranslations === "function" &&
        getTranslations("league_badge_new", "New"),
      matchStatusIcon: "f1i-new-tag",
      matchStatusCls: "si-new",
    },
    JustOpened: {
      matchStatusText: "Just Opened",
      matchStatusIcon: "f1i-live-timing",
      matchStatusCls: "si-justOpened",
    },
    LastChanceJoin: {
      matchStatusText:
        typeof getTranslations === "function" &&
        getTranslations("league_badge_last_chance", "Last Chance to Join"),
      matchStatusIcon: "f1i-timer",
      matchStatusCls: "si-lastChanceJoin",
    },
    LeagueEnded: {
      matchStatusText:
        typeof getTranslations === "function" &&
        getTranslations("league_badge_league_ended", "League Ended"),
      matchStatusIcon: "f1i-flag",
      matchStatusCls: "si-leagueEnded",
    },
  };

  return leagueBadgeList?.[key] ?? {};
};

export const leagueBadgeKeys = {
  1: "Popular",
  2: "New",
  3: "LastChanceJoin",
  4: "LeagueEnded",
};

export const REGISTER_LINK = `https://account.formula1.com/#/en/register`;
export const LOGIN_LINK = `https://account.formula1.com/#/en/login`;
export const DATA_REDIRECT_INTERNAL_VALUE = "internal";
export const DATA_REDIRECT_EXTERNAL_VALUE = "external";

export const LIVE_POINTS_CLASS = "si-livePoints";
export const CALCULATING_POINTS_CLASS = "si-default";

export const LEAGUE_CARD_TEAMS = [1, 2, 3];

export const MINI_LEAGUE_PRIZE_POSITIONS = [
  {
    positionNo: 1,
    positionNoKey: "mini_league_prize_1_position",
    defaultText: "1st",
  },
  {
    positionNo: 2,
    positionNoKey: "mini_league_prize_2_position",
    defaultText: "2nd",
  },
  {
    positionNo: 3,
    positionNoKey: "mini_league_prize_3_position",
    defaultText: "3rd",
  },
];

export const VIP_LEAGUE_KEYS = {
  cloudinaryLeagueType: "Vip Private",
  leagueType: "VIP",
};
